module.exports = __webpack_public_path__ + "img/ic_dependente.d7e70395.svg";